export default __webpack_public_path__ + "static/media/Green-House-Gas.42803d5e.svg";